import { produce } from "immer";

import { normalizeBase } from "@ds/model/helpers";

import { isAssetQueryOutput, isAssetArray } from "./model";

const normalizer = (entity: Asset): Asset =>
  normalizeBase({
    playlist_id: undefined,
    dimensions: undefined,
    duration: undefined,
    thumbnail: undefined,
    ...entity,
  });

export const normalize = ((
  entityOrEntities: Asset | Asset[] | QueryOutput<Asset>,
): Asset | Asset[] | QueryOutput<Asset> => {
  if (isAssetQueryOutput(entityOrEntities)) {
    return produce(entityOrEntities, draft => {
      draft.items = entityOrEntities.items.map(normalizer);
    });
  }

  return isAssetArray(entityOrEntities) ? entityOrEntities.map(normalizer) : normalizer(entityOrEntities);
}) as {
  (asset: Asset): Asset;
  (assets: Asset[]): Asset[];
  (assetsQueryOutput: QueryOutput<Asset>): QueryOutput<Asset>;
};
